/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/062-coin-pound': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M7.5 1a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 13.5a6 6 0 110-12 6 6 0 010 12z"/><path pid="1" d="M9.5 11H6V9h1.5a.5.5 0 000-1H6v-.5a1.502 1.502 0 012.8-.75.499.499 0 10.865-.501A2.51 2.51 0 007.5 4.999a2.503 2.503 0 00-2.5 2.5v.5h-.5a.5.5 0 000 1H5v3h4.5a.5.5 0 000-1z"/>'
  }
})
